/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecordingManualChangesResponseFieldsArtistsItemsInner
 */
export interface RecordingManualChangesResponseFieldsArtistsItemsInner {
    /**
     * 
     * @type {string}
     * @memberof RecordingManualChangesResponseFieldsArtistsItemsInner
     */
    op: string;
    /**
     * 
     * @type {string}
     * @memberof RecordingManualChangesResponseFieldsArtistsItemsInner
     */
    artistId: string;
    /**
     * 
     * @type {string}
     * @memberof RecordingManualChangesResponseFieldsArtistsItemsInner
     */
    stageName?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordingManualChangesResponseFieldsArtistsItemsInner
     */
    featuredStatus?: string | null;
}

/**
 * Check if a given object implements the RecordingManualChangesResponseFieldsArtistsItemsInner interface.
 */
export function instanceOfRecordingManualChangesResponseFieldsArtistsItemsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "artistId" in value;

    return isInstance;
}

export function RecordingManualChangesResponseFieldsArtistsItemsInnerFromJSON(json: any): RecordingManualChangesResponseFieldsArtistsItemsInner {
    return RecordingManualChangesResponseFieldsArtistsItemsInnerFromJSONTyped(json, false);
}

export function RecordingManualChangesResponseFieldsArtistsItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordingManualChangesResponseFieldsArtistsItemsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'op': json['op'],
        'artistId': json['artist_id'],
        'stageName': !exists(json, 'stageName') ? undefined : json['stageName'],
        'featuredStatus': !exists(json, 'featuredStatus') ? undefined : json['featuredStatus'],
    };
}

export function RecordingManualChangesResponseFieldsArtistsItemsInnerToJSON(value?: RecordingManualChangesResponseFieldsArtistsItemsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'op': value.op,
        'artist_id': value.artistId,
        'stageName': value.stageName,
        'featuredStatus': value.featuredStatus,
    };
}

